export default __webpack_public_path__ + "static/media/vessel.de9a36af.svg";